import { PureComponent } from 'react'
import { array, number } from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { vibrateDuration } from '../../../../../config'
import {
  ShakeEvent,
  shakeListener,
  stopTheShake,
  vibrateDevice,
} from './Factory'

class ShakeComponent extends PureComponent {
  componentDidMount = () => {
    ShakeEvent.start()
    shakeListener(this.handleShake)
  }

  handleShake = () => {
    this.props.history.push(
      `/${this.props.center[0]}:${
        this.props.center[1]
      }/${this.props.category.join(',')}/${this.props.radius}`
    )
    vibrateDevice(vibrateDuration)
  }

  componentWillUnmount = () => {
    stopTheShake(this.handleShake)
  }

  render() {
    return null
  }
}

ShakeComponent.propTypes = {
  center: array.isRequired,
  category: array.isRequired,
  radius: number.isRequired,
}

const mapStateToProps = ({ spi, map }) => ({
  center: map.center,
  category: spi.category,
  radius: map.radius,
})

export default withRouter(connect(mapStateToProps)(ShakeComponent))



// WEBPACK FOOTER //
// ./src/components/Elements/DeviceEvents/ShakeSearch/ShakeComponent/index.jsx